<template>
  <app-view-default-template class="app-view-default-template-news-profile" :showDisclaimer="true">

    <!-- Title component   -->
    <app-content-title :label="title"></app-content-title>

    <b-row>
      <b-col xs="12" sm="12" :md="structureMD">
        <div class="type-wrapper">
          <div class="type" :class="type + '-color'">
            <p>{{ releaseTypeHandler(type) }}</p>
          </div>

          <div class="is-regulatory">
            <p v-if="isRegulatory">Regulatory</p>
            <p v-else>Non-regulatory</p>
          </div>
        </div>

        <div class="published">
          <p>
            <i>Publish date: <b>{{ date }} {{ getTimeZone }} {{ fromNowDate }}</b></i>
          </p>
        </div>

        <div class="content">
          <div v-dompurify-html="htmlIntro"></div>
          <div v-dompurify-html="htmlBody"></div>
          <div v-dompurify-html="htmlCompanyInfo"></div>
        </div>
      </b-col>

      <b-col xs="12" sm="12" md="4" v-if="isSidebarVisible">
        <b-row>
          <b-col xs="12" sm="6" md="12">
            <sidebar-images v-if="isSidebarImagesVisible" :class="type + '-color'" :images="imagesSidebar"/>
          </b-col>

          <b-col xs="12" sm="6" md="12">
            <sidebar-files-table v-if="isSidebarFilesVisible" :class="type + '-color'" :items="getTableFilesItems" :fields="filesTable.fields"/>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    
  </app-view-default-template>
</template>

<script>
  // Template
  import AppViewDefaultTemplate from '@/components/layout/templates/view/AppViewTemplateDefaultWithSubscription';
  import AppContentTitle from '@/components/ui/titles/AppContentTitle';

  // Models
  import ReleaseApi from "@/services/release";

  // Components
  import SidebarImages from '@/components/layout/templates/sidebar/SidebarImages';
  import SidebarFilesTable from '@/components/layout/templates/sidebar/SidebarFilesTable';

  // Mixins
  import {mixinDatesHandler} from '@/mixins/dates-handler';

  // Configs
  import DatesConfig from "@/configs/dates";

  // Constant
  const UI_DEFAULT_DATE_TIME_FORMAT = DatesConfig.UI_DEFAULT_DATE_TIME_FORMAT;

  export default {
    name: 'NewsProfile',

    mixins: [mixinDatesHandler],

    components: {
      AppViewDefaultTemplate, AppContentTitle, SidebarImages, SidebarFilesTable
    },

    data: function () {
      return {
        isRegulatory: null,
        title: null,
        type: null,
        publishDate: null,
        htmlIntro: null,
        htmlBody: null,
        htmlCompanyInfo: null,
        images: [],
        files: [],

        filesTable: {
          fields: [
            {
              key: 'type',
              sortable: false
            },
            {
              key: 'fileName',
              sortable: false
            },
            {
              key: 'url',
              sortable: false,
            }
          ],
          items: [],
        }
      }
    },

    methods: {
      getProfile() {
        const data = {
          params: {
            isCleanHtml: true,
          }
        };

        const releaseId = this.$route.params.releaseId;

        let _this = this;
        new ReleaseApi(data, {urlExtension: releaseId}).get(function (response) {
          if (response.status !== 200) {
            _this.$router.push({
              name: 'PageNotFound'
            })
          }

          _this.title            = response.data.Release.Title;
          _this.type             = response.data.Release.InformationType;
          _this.publishDate      = response.data.Release.PublishDate;
          _this.htmlIntro        = response.data.Release.HtmlIntro;
          _this.htmlBody         = response.data.Release.HtmlBody;
          _this.htmlCompanyInfo  = response.data.Release.HtmlCompanyInformation;
          _this.images           = response.data.Release.Images;
          _this.filesTable.items = _this.setFilesSidebar(response.data.Release.Files);
          _this.isRegulatory     = response.data.Release.IsRegulatory;
        });
      },

      dateHandler(obj) {
        const date  = obj.CreatedDate;
        let newDate = '';

        if (this._mixinDateHandler_IsValidDate(date)) {
          newDate = this._mixinDateHandler_ApiResponseDateTimeToFormat(date, 'YYYY-MM-DD', true);
        }

        obj.CreatedDate = newDate;

        return obj;
      },

      getFileExtension(fileName) {
        return fileName.substr(fileName.lastIndexOf('.') + 1);
      },

      setFilesSidebar(files) {
        let newFiles = [];

        if (files) {
          files.forEach((x) => {
            newFiles.push({
              'type': this.getFileExtension(x.FileName),
              'url': x.Url,
              'fileName': x.FileName,
              'title': x.Title,
              'createDate': this._mixinDateHandler_ApiResponseDateTimeToFormat(x.CreateDate, 'YYYY-MM-DD HH:mm:ss', true),
            });
          });
        }

        return newFiles;
      },

      releaseTypeHandler(type) {
        if (type === 'KMK') {
          return 'Financial';
        } else if (type === 'RDV') {
          return 'Reports';
        } else if (type === 'PRM') {
          return 'Press';
        } else if (type === 'RPT') {
          return 'Reports';
        } else if (type === 'INB') {
          return 'Invitations';
        } else if (type === 'NBR') {
          return 'News';
        }

        return 'Other';
      }
    },

    computed: {
      imagesSidebar() {
        const images  = this.images;
        let newImages = [];

        images.forEach((x) => {
          newImages.push({
            'title': x.Title,
            'src': x.UrlTo400x400ArResized,
            'downloadUrl': x.DownloadUrl,
          });
        });

        return newImages;
      },

      getTableFilesItems() {
        return this.filesTable.items;
      },

      getTimeZone() {
        return this._mixinDateHandler_GetTimeZoneAbbr();
      },

      fromNowDate() {
        const date = this.publishDate;

        if (!this._mixinDateHandler_IsValidDate(date)) {
          return '';
        }

        return `(${this._mixinDateHandler_ApiResponseDateFromNow(date, true)})`;
      },

      date() {
        const date = this.publishDate;

        if (!this._mixinDateHandler_IsValidDate(date)) {
          return '';
        }

        return this._mixinDateHandler_ApiResponseDateTimeToFormat(date, UI_DEFAULT_DATE_TIME_FORMAT, true);
      },

      isSidebarVisible() {
        return this.isSidebarFilesVisible || this.isSidebarImagesVisible;
      },

      isSidebarImagesVisible() {
        return this.images.length > 0;
      },

      isSidebarFilesVisible() {
        return this.filesTable.items.length > 0;
      },

      structureMD() {
        return this.isSidebarVisible ? 8 : 12;
      }
    },

    mounted: function () {
      this.$nextTick(function () {
        this.getProfile();
      });
    },
  }
</script>

<style scoped lang="scss">
  .app-view-default-template-news-profile {
    background-color: white;
    min-height: calc(100vh - 100px);

    .published {
      p {
        font-size: 12px;
      }
    }

    .type-wrapper {
      width: 100%;
      margin-bottom: 10px;

      .type {
        display: inline-block;
        padding: 3px 15px;
        border-radius: 20px;
        color: white;
        margin-right: 10px;

        p {
          font-size: 14px;
          line-height: 1.4;
          font-weight: bold;
          margin-bottom: 0;
        }

        &.KMK-color {
          background-color: #192e5b;
        }

        &.RDV-color {
          background-color: #1e65a7;
        }

        &.PRM-color {
          background-color: #73a2c0;
        }

        &.RPT-color {
          background-color: #00743f;
        }

        &.INB-color {
          background-color: #f1a104;
        }

        &.NBR-color {
          background-color: #9a1c1c;
        }
      }

      .is-regulatory {
        display: inline-block;
        padding: 3px 15px;
        border-radius: 20px;
        color: white;

        p {
          font-size: 14px;
          line-height: 1.4;
          font-weight: bold;
          margin-bottom: 0;
        }

        background-color: #959595;
      }
    }

    /* Dynamic html */
    ::v-deep.content {
      width: 100%;
      margin-bottom: 60px;

      img {
        max-width: 100% !important;
      }

      ul li, ol li {
        p {
          margin-bottom: 0 !important;
        }
      }
    }
  }
</style>
